module.exports = __webpack_public_path__ + "static/media/OsmosisTypeface.7c423fef.svg";